<div id='thank-you'>

	<div class='heading-block' *ngIf='formService.aboutToRedirect'>
		<div class='only-inner-container'>
			<div class='inner-content'>
				<div class='title'>🎉 <ng-container i18n>Success! Redirecting to your Personal Dashboard...</ng-container></div>
				<div class='text' i18n>In a few seconds you will be redirected. If you don't wish to wait, please click below:</div>
				<div class='button-position'>
					<a *ngIf='!loadingAnimationBeforeRedirecting' class='button mp-no-track' (click)='waitAndGoToDashboard($event)' href='{{formService.dashboardUrl}}' i18n>Go to Dashboard</a>
					<div *ngIf='loadingAnimationBeforeRedirecting' class='loader'>
						<div class='loader-spinner'></div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class='heading-block' *ngIf='!formService.aboutToRedirect && formService.failSafeMessage'>
		<div class='only-inner-container'>
			<div class='inner-content'>
				<div class='title' i18n>🎉 The moving companies will start reaching out to you within one working day.</div>
			</div>
		</div>
	</div>

</div>
